<template>
  <div class="moblieContent">
    <header>
      <img
        class="logo"
        :src="require(`@/assets/img/moblie/` + pathId + `/logo.png`)"
        :alt="pathId + 'logo'"
      />
      <div class="headerInfo">
        <h3 class="lotteryTitle mr0">
          {{ title }}
        </h3>
        <p>大数据分析、实时精准推送各种玩法数据的应用工具</p>
      </div>
      <template v-if="enterHelpPage == true">
        <template v-if="downloadHelper == true">
          <div class="downloadContent">
            <a href="#" class="downloadBtn iosDownload" @click="intoSetting">
              立即信任
            </a>
          </div>
        </template>
        <template v-else-if="downloadHelper == false">
          <p class="downloadLoading">桌面正在下载...</p>
          <div class="downloadContent">
            <div class="downloadInfoBlock">
              <div class="purpleTitle purpleBg">下载提示</div>
              <p>
                如果苹果版APP无法使用时，请进入彩世界助手下载最新版APP。如果IOS系统提示无法下载，请重试。请卸载旧版本APP，再到彩世界助手下载安装最新APP。
              </p>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="downloadContent">
          <template v-if="deviceType == 'wx' || deviceType == 'qq'">
            <a href="#" class="downloadBtn"> 微信/QQ内无法下载应用 </a>
          </template>
          <template v-if="deviceType == 'ios'">
            <a
              href="#"
              class="downloadBtn purpleBg"
              style="margin-top: 15px"
              @click="iosDownload"
            >
              <!-- IOS版下载 -->立即下载
            </a>
          </template>
          <template v-if="deviceType == 'android'">
            <a
              href="#"
              class="downloadBtn purpleBg"
              style="margin-top: 15px"
              @click="androidDownload"
            >
              <!-- 安卓版下载 -->立即下载
            </a>
          </template>
        </div>
      </template>
    </header>
    <section :class="downloadHelper == true && 'downloadHelper'">
      <template v-if="enterHelpPage == false">
        <div class="bannerContent">
          <p class="mr0">应用介绍</p>
          <div data-simplebar data-simplebar-auto-hide="false" class="banner">
            <ul
              ref="bannerList"
              class="bannerList"
              :style="{ width: returnSlideW * slides + 140 + 'px' }"
            >
              <li v-for="(slide, i) in slides" :key="i">
                <img
                  :src="
                    require(`@/assets/img/moblie/` +
                      pathId +
                      `/banner${slide}.png`)
                  "
                  alt="banner"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="bottomContent">
          <p>{{ info }}</p>
          <div class="dwTitle">
            <span>快去下载吧！</span>
          </div>
        </div>
      </template>
      <div v-show="enterHelpPage == true" class="flowContent">
        <div class="installFlow">
          <div class="title">
            <span>操作流程</span>
          </div>
          <ol class="flowList">
            <li>
              <p>点击上方“立即下载”按钮下载APP</p>
            </li>
            <li>
              <p>
                微信进入此页，选择[请点击右上角选择“在Safari中打开”]。若您直接在“在Safari中打开”页面，请直接安装。
              </p>
              <img src="@/assets/img/moblie/flow1.png" alt="flow1" />
            </li>
            <li>
              <p>等待桌面上安装成功后，您需再进行一步“信任”操作即可使用。</p>
              <img src="@/assets/img/moblie/flow2.png" alt="flow2" />
              <span>点击[设置]</span>
              <img src="@/assets/img/moblie/flow3.png" alt="flow3" />
              <span>点击[通用]</span>
              <img src="@/assets/img/moblie/flow4.png" alt="flow4" />
              <span>点击[设备管理]</span>
              <img src="@/assets/img/moblie/flow5.png" alt="flow5" />
              <span>点击[企业级应用]</span>
              <img
                :src="require(`@/assets/img/moblie/` + pathId + `/helper1.png`)"
                alt="helper1"
              />
              <span>点击证书[*********]</span>
              <img
                :src="require(`@/assets/img/moblie/` + pathId + `/helper2.png`)"
                alt="helper2"
              />
              <span>最后一步 选择[信任]</span>
              <img
                :src="require(`@/assets/img/moblie/` + pathId + `/helper3.png`)"
                alt="helper3"
              />
            </li>
            <li>
              <p>恭喜您成功下载！</p>
            </li>
          </ol>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  getAndroidDownUrl,
  getIosDownUrl,
  getUrlKey,
  isKeyEmpty,
} from "../../utils/urltool";
export default {
  props: ["pathId", "iosdownload"],
  data() {
    return {
      slides: 4,
      slideW: 200,
      enterHelpPage: false,
      downloadHelper: false,
      iosHelperlink: "https://sy.30oy.com/sychat/helper.mobileconfig",
      iosVerification: "https://sy.30oy.com/sychat/xinren.mobileprovision",
      title: "",
      info: "",
      downChannel: undefined,
      userCode: undefined,
    };
  },
  mounted() {
    if (this.iosdownload == true) {
      this.iosDownload();
    }
    this.scrollToTop();
    let url = window.location.href;
    this.downChannel = getUrlKey("channel", url);
    this.userCode = getUrlKey("user_code", url);
    this.title = this.$store.getters.returnTitle(this.pathId);
    this.info = this.$store.getters.returnInfo(this.pathId);
    if (this.pathId == "liuhe") {
      this.slides = 4;
    } else {
      this.slides = 6;
    }
  },
  computed: {
    ...mapState({
      deviceType: "deviceType",
      lotteryArray: "lotteryArray",
    }),
    returnSlideW: function () {
      return this.slideW;
    },
  },
  methods: {
    iosDownload(e) {
      if (e) {
        e.preventDefault();
      }
      let channelInfo = undefined;
      let dwArray = window.download;
      for (let i = 0; i < dwArray.length; i++) {
        if (this.pathId == dwArray[i].name) {
          channelInfo = dwArray[i];
          break;
        }
      }

      let iosLink = "";
      if (!isKeyEmpty(channelInfo)) {
        if (!isKeyEmpty(this.downChannel)) {
          iosLink = getIosDownUrl(this.downChannel, channelInfo.channels);
          if (isKeyEmpty(iosLink)) {
            this.$store.dispatch("increment", {
              pathName: this.pathId,
              channelCode: this.downChannel,
            });
          }
        } else if (!isKeyEmpty(this.userCode)) {
          // 用户分享下载
          this.$store.dispatch("increment", {
            pathName: this.pathId,
            userCode: this.userCode,
          });
        }

        if (isKeyEmpty(iosLink)) {
          iosLink = channelInfo.iosLink;
        }
        let eventName = `${this.pathId}_ios_download_count`;
        setTimeout(function () {
          window.open(iosLink);
          LA.track(eventName);
        }, 500);
      }
    },
    androidDownload(e) {
      if (e) {
        e.preventDefault();
      }
      let channelInfo = undefined;
      let dwArray = window.download;
      for (let i = 0; i < dwArray.length; i++) {
        if (this.pathId == dwArray[i].name) {
          channelInfo = dwArray[i];
          break;
        }
      }

      let androidLink = "";
      if (!isKeyEmpty(channelInfo)) {
        if (!isKeyEmpty(this.downChannel)) {
          androidLink = getAndroidDownUrl(
            this.downChannel,
            channelInfo.channels
          );
          if (isKeyEmpty(androidLink)) {
            this.$store.dispatch("increment", {
              pathName: this.pathId,
              channelCode: this.downChannel,
            });
          }
        } else if (!isKeyEmpty(this.userCode)) {
          // 用户分享下载
          this.$store.dispatch("increment", {
            pathName: this.pathId,
            userCode: this.userCode,
          });
        }

        if (isKeyEmpty(androidLink)) {
          androidLink = channelInfo.androidLink;
        }
        let eventName = `${this.pathId}_android_download_count`;
        setTimeout(function () {
          window.open(androidLink);
          LA.track(eventName);
        }, 500);
      }
    },
    downloadhelpTool(e) {
      if (e) {
        e.preventDefault();
      }

      var _this = this;

      _this.downloadHelper = true;
      window.location.href = _this.iosHelperlink;
    },
    intoSetting(e) {
      var _this = this;
      if (e) {
        e.preventDefault();
      }

      window.location.href = _this.iosVerification;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

